export default {
  toArray() {
    let results = []

    Object.keys(this).map(key => {
      if (typeof this[key] !== 'function') {
        results.push({
          id: this[key],
          name: this.name ? this.name(this[key]) : this[key]
        })
      }
    })

    return results
  },

  toHash() {
    let results = {}

    Object.keys(this).map(key => {
      if (typeof this[key] !== 'function') {
        results[this[key]] = this.name ? this.name(this[key]) : this[key]
      }
    })

    return results
  }
}
